import { styled } from "@mui/material";

export const StyledMenuSection = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(2),
	padding: theme.spacing(2),
	border: `solid 1px ${theme.palette.borders.primary}`,
	borderRadius: theme.shape.borderRadius,
	marginBottom: theme.spacing(2),
  }));

export const StyledMenuButtonItem = styled('div')(({ theme }) => ({
	padding: '16px 8px',
	borderRadius: 4,
	border: `solid 1px ${theme.palette.borders.primary}`,
	display: 'flex',
	justifyContent: 'center',
	cursor: 'pointer',
}))
